var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group-material col-12 col-lg-3" },
    [
      _c("select2", {
        attrs: {
          id: _vm.nameSelectId,
          data: _vm.data,
          value: _vm.value,
          name: "conditionName",
          options: _vm.options,
          "format-data": _vm.formatData,
          "init-on-mounted": true,
          multiple: false,
          required: true,
        },
        on: { change: _vm.handleChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }